import React from "react";
import Commons from "oc-commons/Commons";
import Select from "../commons/Select";
import SidebarFrame from "./SidebarFrame";
import OptionInput from "../commons/OptionInput";
import DekorInput from "../commons/DekorInput";
import CheckboxInput from "../commons/CheckboxInput";
import ReactPaginate from "react-paginate";
import SchrankInput from "../commons/SchrankInput.jsx";
import MeasureNumberInput from "../commons/MeasureNumberInput.js";

export default class SockelFarbenSettings extends SidebarFrame {
    constructor(params) {
        super(params);
        this.params = params;
    }

    state = {
        sockelFarbe: "rot"
    }

    sockelEnabled() {
        const currentSchrankModellName = APP.arrangement.schraenke[APP.arrangement.currentSchrankIndex].modell.Name
        const werte = APP.metadata.Modellwerte[currentSchrankModellName];
        return werte ? werte["sockel"] : false;
    }

    setSockelMaterial(value) {
        const newMaterialArtikel = APP.arrangement.findProduct(value);
        if(newMaterialArtikel) {
            APP.arrangement.selectedSchrank.sockel.materialArtikelnummer = newMaterialArtikel;
            
        }
    }

    render() {
        
        const sockelFarben = APP.getMaterialsForDekorTyp("front").filter(m => m);

        return (
            <div className="appear">
                {sockelFarben.length > 1 && (
                    <DekorInput 
                        key={"sockelDekor"}
                        label={I18N(`Welches SockelDekor wünschen Sie?`)}
                        dekore={sockelFarben}
                        value={this.state.sockelFarbe}
                        appear={true}
                        setValue={(value, option) => {
                            this.setSockelMaterial(value);
                        }}
                    />
                )}
            </div>
        )
    }
}
